module.exports = __webpack_public_path__ + "img/120.1b79b9c2.jpg";